import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-598b7393"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = { class: "job-listing-area pt-120 mb-120" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row g-lg-4 gy-5" }
const _hoisted_8 = { class: "col-lg-12 order-lg-2 order-1" }
const _hoisted_9 = { class: "job-listing-wrrap" }
const _hoisted_10 = { class: "row g-4 mb-25" }
const _hoisted_11 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "show-item"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 d-flex align-items-center justify-content-lg-end" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid-select-area" })
], -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "job-listing-card" }
const _hoisted_16 = { class: "job-top" }
const _hoisted_17 = { class: "job-list-content" }
const _hoisted_18 = {
  class: "company-area",
  style: {"min-width":"fit-content"}
}
const _hoisted_19 = { class: "logo" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "company-details" }
const _hoisted_22 = { class: "name-location" }
const _hoisted_23 = { class: "job-discription" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Salary:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Application Close:", -1))
const _hoisted_26 = { style: {"line-height":"1.5rem"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Summary: ", -1))
const _hoisted_28 = { class: "job-type-apply" }
const _hoisted_29 = { class: "job-type" }
const _hoisted_30 = { class: "light-green" }
const _hoisted_31 = {
  key: 0,
  class: "apply-btn"
}
const _hoisted_32 = {
  key: 0,
  class: "col-lg-12 d-flex justify-content-center"
}
const _hoisted_33 = { class: "pagination-area" }
const _hoisted_34 = { "aria-label": "..." }
const _hoisted_35 = { class: "pagination" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "col-lg-12 d-flex justify-content-center"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagination-area" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "No result found")
], -1))
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, _toDisplayString(_ctx.jobs.data ? _ctx.jobs.data[0]?.category : 'No Category'), 5)
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.jobs.total > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Showing results " + _toDisplayString(_ctx.jobs.per_page) + " in " + _toDisplayString(_ctx.jobs.total) + " jobs list", 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs.data, (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: job.id,
                    class: "col-lg-12 mb-30"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("img", {
                                src: (job.company_logo) ? job.company_logo : '/assets/images/work-pages-logo.png',
                                alt: ""
                              }, null, 8, _hoisted_20)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("h5", null, [
                                  _createVNode(_component_router_link, {
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.job_title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_router_link, {
                                    to: '/company-details?company_id=' + job.company_id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.company), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("ul", null, [
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_24,
                                  _createTextVNode(" " + _toDisplayString(job.salary_range), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", null, [
                                  _hoisted_25,
                                  _createTextVNode(_toDisplayString(job.expiration), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("p", _hoisted_26, [
                                  _hoisted_27,
                                  _createTextVNode(_toDisplayString(job.job_description.slice(0, 30)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(job.working_mode) + " " + _toDisplayString(job.expiration), 1)
                        ]),
                        (!_ctx.isJobExpired(job.expiration))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (_ctx.loggedIn)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "primry-btn-2 y-btn lg-btn",
                                    to: _ctx.getJobDetail(job.job_key, job.job_slug, 'apply')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Apply Now")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { name: 'login' },
                                    class: "primry-btn-2 y-btn lg-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Login to apply")
                                    ]),
                                    _: 1
                                  }))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.jobs.total > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("nav", _hoisted_34, [
                          _createElementVNode("ul", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs.links, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass(["page-item", { 'active': item.active == true, 'd-none': item.label.includes('Previous') || item.label.includes('Next') }])
                              }, [
                                _createElementVNode("button", {
                                  class: "page-link",
                                  onClick: ($event: any) => (_ctx.toPage(item.url))
                                }, _toDisplayString(item.url ==
                                                        null ? '<' : item.label), 9, _hoisted_36)
                              ], 2))
                            }), 256))
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}